var map = {
	"./cz.json": 6249,
	"./ee.json": 5488,
	"./en.json": 7518,
	"./fi.json": 2276,
	"./lt.json": 1560,
	"./lv.json": 9071,
	"./pl.json": 5143,
	"./se.json": 9546,
	"./sk.json": 1941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8973;